import React, { useEffect, useState } from "react";
import API from '../api';

function LatestAlertScroller() {
  const [latest_alerts, setLatestAlerts] = useState([]);

  useEffect(() => {
    loadAlerts();
    const interval = setInterval(loadAlerts, 150000); // refresh every 15s
    return () => clearInterval(interval);
  }, []);

  const loadAlerts = async () => {
    try {
      const res = await API.get('api/latest-alerts');
     const list = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.data)
        ? res.data.data
        : [];

      setLatestAlerts(list);
    } catch (err) {
      console.error("Alert fetch failed");
    }
  };

  return (
    <div className="latest-alert-box">
      <h4 className="text-center mb-3">Latest Sent Stock Alerts</h4>

      <div className="alert-scroller">
        <ul>
          {latest_alerts.map(a => (
            <li key={a.id}>
              <span>{a.message}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LatestAlertScroller;
